import { TreeType } from '../markdown.types';

export const renderTextFromTree = ({ tree }: { tree: TreeType }): string => {
  return tree.reduce((acc, currentValue) => {
    if (Array.isArray(currentValue.content)) {
      return `${acc}${renderTextFromTree({ tree: currentValue.content })}`;
    }
    return `${acc}${currentValue.content}`;
  }, '');
};
